<script>
// import { page } from "$app/stores";
import { resolve } from "$app/paths";

import { DarkMode, NavLink, SocialLinks } from "$lib/components";
import { navigations } from "$lib/data";
import { localizeHref } from "$lib/paraglide/runtime";

// import { cn } from "$lib/utils";

// const _container = cn(
//   "mx-auto",
//   "w-full",
//   "max-w-[85rem]",
//   "px-4",
//   "py-6",
//   "sm:px-6",
//   "lg:px-8",
// );
</script>

<header class="bg-white dark:bg-black">
  <nav class="container flex flex-col items-center justify-between gap-4 sm:flex-row sm:gap-1" aria-label="Global">
    <div class="flex flex-1">
      <a href={resolve(localizeHref("/"))} class="">
        <span class="sr-only">Ali Samar</span>
        <img class="h-8 w-8" src="/logo.svg" alt="" />
      </a>
    </div>

    <!-- Main Menu -->
    <div class="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 lg:gap-x-6">
      {#each navigations.items as item, index ((index, item.title))}
        <NavLink href={item.href}>{item.title}</NavLink>
      {/each}
    </div>

    <!-- Social Links -->
    <div class="hidden w-full flex-1 justify-around sm:flex sm:justify-end">
      <SocialLinks
        class="bg-base-transparent inline-flex size-9 shrink-0 items-center justify-center rounded-full font-medium text-base-12 transition-all duration-300 hover:bg-base-4 focus:bg-base-3 focus:outline-none"
      >
        <DarkMode class="hidden sm:inline" />
      </SocialLinks>
    </div>

    <!-- Menu -->
    <div id="mobile-menu" class="hs-collapse hidden lg:gap-x-6">
      <ul>
        {#each navigations.items as item, index (("mobile", index, item.title))}
          <li>
            <NavLink href={item.href}>{item.title}</NavLink>
          </li>
        {/each}
      </ul>
    </div>
  </nav>
</header>
